import type { Order } from '@sg/graphql-schema';

import type { AddressType } from '@garnish/location';

/**
 * The `outpost` type is derived from the order restaurant.
 */
export const getOrderType = (order?: Order): AddressType => {
  if (order?.restaurant?.isOutpost) return 'outpost';

  return (order?.orderType?.toLowerCase() ?? 'pickup') as AddressType;
};
